<div class="container">
  <div class="row">
    <div class="col-4">
      <div class="card">
        <h2 class="card-label">Total Users</h2>
        <h2 class="card-value">20</h2>
      </div>
    </div>
    <div class="col-4">
      <div class="card">
        <h2 class="card-label">Total Chats</h2>
        <h2 class="card-value">1594</h2>
      </div>
    </div>
    <div class="col-4">
      <div class="card">
        <h2 class="card-label">Positive Sentiments</h2>
        <h2 class="card-value">1204</h2>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <canvas baseChart [data]="barChartData" [options]="barChartOptions" [type]="'bar'"> </canvas>
    </div>
    <div class="col-4">
      <canvas baseChart [data]="pieChartData" [options]="pieChartOptions" [type]="'pie'"> </canvas>
      </div>
    <div class="col-4">
      <canvas baseChart [data]="lineChartData" [options]="lineChartOptions" [type]="'line'"> </canvas>
    </div>
  </div>
</div>
